import React from 'react';
import FavoritesCity from '../components/FavoritesCity';

function FavoriteScreen() {
  return (
    <div className="FavoriteScreen">
        <div className="container">
            <div className="row">
                <FavoritesCity />
            </div>
        </div>  
    </div>
  );
}

export default FavoriteScreen;
